export default (el) => ({
  id: String(el.id),
  title: el.title || '',
  address: el.address || '',
  buildingId: String(el.building_id),
});
